import { infiniteQueryOptions, useInfiniteQuery } from '@tanstack/react-query';

import { helpCenterApi } from '../api/help-center-api';

import { helpCenterKeys } from './help-center-keys';

export const FEEDBACK_PAGE_SIZE = 10;

/** Latest votes first; the editor appends older ones with "Load more". */
export function helpArticleFeedbackQueryOptions(storeId: string, articleId: string) {
  return infiniteQueryOptions({
    queryKey: helpCenterKeys.feedback(storeId, articleId),
    queryFn: ({ pageParam }) =>
      helpCenterApi.listFeedback(storeId, articleId, {
        limit: FEEDBACK_PAGE_SIZE,
        ...(pageParam ? { cursor: pageParam } : {}),
      }),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (page) => page.nextCursor ?? undefined,
  });
}

export function useHelpArticleFeedback(storeId: string, articleId: string) {
  return useInfiniteQuery(helpArticleFeedbackQueryOptions(storeId, articleId));
}
